export enum BannerType {
  All = 0,
  ECF = 1,
  MYsec = 2,
}
